import React from "react";
import { Axios } from "../../Services/Axios/index";
import * as xlsx from "xlsx";
import ReactPaginate from "react-paginate";
import { useSelector } from "react-redux";
import { decryptData, Storage } from "../../Services/Storage";
import { act } from "@testing-library/react";
import { fetchPermissions } from "../../Components/sidebar";
import { toast } from "react-toastify";

export const Inquiry = () => {
  const center = useSelector((e) => e.Center);
  const [dataValues, setdataValues] = React.useState([]);
  const [inquiry, setInquiry] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [filtered, setFiltered] = React.useState([]);
  const [permissions, setPermissions] = React.useState([]);
  const [itemOffset, setItemOffset] = React.useState(0);
  const [pageCount, setPageCount] = React.useState(0);
  const { id, role, centresId } = Storage.getItem("user");

  React.useEffect(() => {
    const endOffset = itemOffset + 10;
    let tt = [...dataValues];
    // console.log(`Loading items from ${itemOffset} to ${endOffset}`);
    setFiltered(tt.slice(itemOffset, endOffset));
  }, [itemOffset, dataValues]);

  const handlePage = (event) => {
    const newOffset = (event.selected * 10) % dataValues.length;
    setItemOffset(newOffset);
  };
  React.useEffect(() => {
    fetchPermissions(id)
      .then((res) => {
        const permission = res.find((item) => item.title == "Events");
        // console.log(permission);
        setPermissions(permission);
      })
      .catch((err) => {
        toast.error("Uncaught error");
      });
  }, []);

  React.useEffect(() => {
    GetAllInquiry();
  }, [center]);


  // Define removeDuplicates function outside the component
  // Define removeDuplicates function outside the component
  const removeDuplicates = (array) => {
    const seen = new Set();
    return array.filter((item) => {
      // Create a key based on Name, Phone, Email, and Course
      const key = JSON.stringify({
        Name: item.uname,
        Phone: item.uphne,
        Email: item.uemail,
        Course: item.course,
      });

      // If this combination hasn't been seen, add it to the Set and keep it
      if (!seen.has(key)) {
        seen.add(key);
        return true;
      }

      return false;
    });
  };

  const GetAllInquiry = () => {
    setLoading(true);
    if (role === "admin") {
      Axios.get(
        `/Inquiries/GetByCenterId?Id=${Boolean(center)
          ? decryptData(center)?.id
          : "00000000-0000-0000-0000-000000000000"
        }`
      ).then(
        (res) => {
          setInquiry([]);
          // Remove duplicates based on Name, Phone, Email, and Course
          let a = removeDuplicates(res.data?.reverse());
          a.forEach((x) => {
            let payload = {
              Name: x.uname,
              Phone: x.uphne,
              Email: x.uemail,
              City: x.currentCity,
              Course: x.course,
              Center: x.centres ? x.centres : "---",
              Date: x.createdDate ? x.createdDate?.split("T")[0] : "---",
            };
            setInquiry((p) => [...p, payload]);
            x.centres = x.centres ? x.centres : "---";
          });
          setdataValues(a);
          setPageCount(Math.ceil(a.length / 10));
          setLoading(false);
        },
        () => { }
      );
    } else {
      Axios.get(`/Inquiries/GetByCenterId?Id=${centresId}`).then(
        (res) => {
          setInquiry([]);
          // Remove duplicates based on Name, Phone, Email, and Course
          let a = removeDuplicates(res.data?.reverse());
          a.forEach((x) => {
            let payload = {
              Name: x.uname,
              Phone: x.uphne,
              Email: x.uemail,
              City: x.currentCity,
              Course: x.course,
              Center: x.centres ? x.centres : "---",
              Date: x.createdDate ? x.createdDate?.split("T")[0] : "---",
            };
            setInquiry((p) => [...p, payload]);
            x.centres = x.centres ? x.centres : "---";
          });
          setdataValues(a);
          setPageCount(Math.ceil(a.length / 10));
          setLoading(false);
        },
        () => { }
      );
    }
  };

  const Excel = () => {
    try {
      const exportData = dataValues.map(x => ({
        Name: x.uname || "---",
        Phone: x.uphne || "---",
        Email: x.uemail || "---",
        City: x.currentCity || "---",
        Course: x.course || "---",
        Center: x.centres || "---",
        Date: x.createdDate ? x.createdDate.split("T")[0] : "---",
      }));

      let book = xlsx.utils.book_new();
      let sheet = xlsx.utils.json_to_sheet(exportData);
      xlsx.utils.book_append_sheet(book, sheet, "Inquiries");
      xlsx.writeFile(book, "Course_Inquiry.xlsx");
    } catch (error) {
      console.error("Export to Excel failed:", error);
      toast.error("Failed to export to Excel");
    }
  };

  return (
    <div className="flex-1 p-6 font-[Poppins]">
      <div className="flex flex-col md:flex-row justify-between items-center mb-6">
        <div>
          <h2 className="text-2xl font-bold text-gray-800">Course Inquiry</h2>
          <p className="text-gray-500 text-sm mt-1">Manage and view all course inquiries across centers.</p>
        </div>
        <button
          className="mt-4 md:mt-0 flex items-center gap-2 bg-[#FCC90D] hover:bg-[#e6b60c] text-gray-900 font-semibold py-1.5 px-4 text-sm rounded-lg transition-all duration-200 shadow-sm"
          title="Export Excel"
          type="button"
          onClick={Excel}
        >
          Export to Excel
        </button>
      </div>

      <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-left border-collapse">
            <thead>
              <tr className="bg-gray-50 border-b border-gray-100 text-xs text-gray-500 font-semibold uppercase tracking-wider">
                <th className="px-6 py-4">Name</th>
                <th className="px-6 py-4">Phone</th>
                <th className="px-6 py-4">Email</th>
                <th className="px-6 py-4">Course</th>
                <th className="px-6 py-4">Center</th>
                <th className="px-6 py-4">Date</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100 text-sm text-gray-700">
              {loading && (
                <tr>
                  <td colSpan="6" className="px-6 py-8 text-center text-gray-500">
                    Loading inquiries...
                  </td>
                </tr>
              )}
              {!loading && dataValues.length === 0 && (
                <tr>
                  <td colSpan="6" className="px-6 py-8 text-center text-gray-500">
                    No data found.
                  </td>
                </tr>
              )}
              {!loading && dataValues.length > 0 &&
                filtered.map((data, i) => (
                  <tr key={i} className="hover:bg-gray-50 transition-colors">
                    <td className="px-6 py-4 whitespace-nowrap font-medium text-gray-900">{data.uname}</td>
                    <td className="px-6 py-4 whitespace-nowrap">{data.uphne}</td>
                    <td className="px-6 py-4 max-w-[200px] truncate" title={data.uemail}>{data.uemail}</td>
                    <td className="px-6 py-4 whitespace-nowrap">{data.course}</td>
                    <td className="px-6 py-4 whitespace-nowrap">{data.centres}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-gray-500">{data.createdDate?.split("T")[0]}</td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
        
        {!loading && pageCount > 1 && (
          <div className="p-4 border-t border-gray-100 bg-white flex justify-center">
            <ReactPaginate
              breakLabel="..."
              nextLabel="Next &raquo;"
              onPageChange={handlePage}
              pageRangeDisplayed={5}
              pageCount={pageCount}
              previousLabel="&laquo; Prev"
              renderOnZeroPageCount={null}
              containerClassName="flex items-center gap-2 text-sm select-none"
              pageClassName="rounded-lg border border-gray-200 overflow-hidden"
              pageLinkClassName="block px-3 py-1.5 bg-white text-gray-700 hover:bg-gray-50 transition-colors cursor-pointer"
              activeClassName="border-[#FCC90D] ring-1 ring-[#FCC90D]"
              activeLinkClassName="!bg-[#FCC90D] !text-gray-900 font-semibold"
              nextClassName="rounded-lg border border-gray-200 overflow-hidden ml-2"
              nextLinkClassName="block px-3 py-1.5 bg-white text-gray-700 hover:bg-gray-50 transition-colors cursor-pointer font-medium"
              previousClassName="rounded-lg border border-gray-200 overflow-hidden mr-2"
              previousLinkClassName="block px-3 py-1.5 bg-white text-gray-700 hover:bg-gray-50 transition-colors cursor-pointer font-medium"
              disabledClassName="opacity-50 pointer-events-none"
            />
          </div>
        )}
      </div>
    </div>
  );
};
